import script from "./ListaTrilhaDeCuidados.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaTrilhaDeCuidados.vue?vue&type=script&setup=true&lang=js"

import "./ListaTrilhaDeCuidados.vue?vue&type=style&index=0&id=619a735a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619a735a"]])

export default __exports__